import { render, staticRenderFns } from "./FeedBasicVoice.vue?vue&type=template&id=d5336018"
import script from "./FeedBasicVoice.vue?vue&type=script&lang=js"
export * from "./FeedBasicVoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports